import { generatedEntry } from './catalog.generated';

export const copyCatalog = {
  titles: {
    offline: 'You appear to be offline',
    generic: 'Something went wrong',
  },
  messages: {
    offline: 'Check your internet connection, then try again.',
    generic: 'Something went wrong. Please try again.',
  },
} as const;

export function titleForCode(code: string | undefined, httpStatus?: number): string {
  const generated = generatedEntry(code);
  if (generated?.title) return generated.title;
  if (httpStatus === 401) return 'Session invalid';
  if (httpStatus === 403) return 'Access denied';
  if (httpStatus === 404) return 'Not found';
  if (httpStatus === 429) return 'Slow down';
  if (httpStatus === 503) return 'Service unavailable';
  if (httpStatus === 400) return 'Invalid input';
  return copyCatalog.titles.generic;
}

export function messageForInline(code: string | undefined, backendMessage: string): string {
  const generated = generatedEntry(code)?.message;
  return backendMessage || generated || copyCatalog.messages.generic;
}
